import styled from 'styled-components/macro';

export const InputWrapper = styled.div`
  .cogs-input {
    width: 100%;
  }
  margin-bottom: 8px;
`;
